module.exports = __webpack_public_path__ + "assets/check-filled.1bb3b562.svg";